module.exports = __webpack_public_path__ + "static/img/Reading_room1.d4d8f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Reading_room1.png
// module id = qnbi
// module chunks = 0